import {Link} from 'react-router-dom'
import logo from "../images/Logo-long.png"
import { footerLinks } from '../data'
import { SiBluesky } from "react-icons/si"
import { AiFillInstagram } from "react-icons/ai"




const Footer = () => {
  return (
    <footer>
        <div className='container footer__container'>
            <article>
                <Link to="/" className='logo'>
                    <img src={logo} alt="Footer logo" />
                    </Link>
                    <p>
                    Igniting inspiration and transformation in the Iyengar tradition. Be inspired. Yoga for all levels.
                    </p>
                    <div className="footer__socials">
                        <a href="https://www.bluesky.com" target="_blank" rel="noreferrer"><SiBluesky/></a>
                        <a href="https://www.instagram.com" target="_blank" rel="noreferrer"><AiFillInstagram/></a>
                         </div>
            </article>
            <article>
                <h4>Permalinks</h4>
                <Link to="/about">About</Link>  
                <Link to="/gallery">Gallery</Link>  
                <Link to="/pricing">Pricing</Link>  
                <Link to="/Teachers">Teachers</Link>  
                <Link to="/contact">Contact</Link>
                <Link to="/my-bookings">My Bookings</Link>  
            </article>
            <article>
                <h4>Insights</h4>
                {/* <Link to="/programs/#">Programs</Link>   */}
                <Link to="/s">Case Studies</Link>  
                <Link to="/s">Events</Link>  
                <Link to="/s">Community</Link>  
                  {footerLinks.map(({ id, name, path }) => (
                    path.startsWith('/')
                      ? <Link key={id} to={path}>{name}</Link>
                      : <a key={id} href={path} target="_blank" rel="noreferrer">{name}</a>
                ))}
                <Link to="/s">FAQs</Link>   
            </article>
            <article>
                <h4>Get in Touch</h4> 
                <Link to="/contact">Contact Us</Link>   
                <Link to="/s">Support</Link>   
            </article>
            </div>
            <div className="footer__copyright">
            <small>2026 TA2 &copy; All rights reserved</small>
            </div>
    </footer>
  )
}

export default Footer